import PropTypes from 'prop-types'
import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * Id of the dropdown button
   */
  id: PropTypes.string.isRequired,
  /**
   * Title of the dropdown button (must be a FormattedMessage id)
   */
  title: PropTypes.string.isRequired,
  /**
   * Items of each option of the dropdown
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Id of the dropdown option
       */
      id: PropTypes.string.isRequired,
      /**
       * Label of the dropdown option (must be a FormattedMessage id)
       */
      label: PropTypes.string.isRequired,
      /**
       * Callback function for when the option is clicked
       */
      onClick: PropTypes.func,
    }),
  ),
  /**
   * variant of the toggle button
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark', 'link']),
  toggleClassName: PropTypes.string,
  /** Bootstrap button size — use `sm` to align with `form-control-sm` in toolbars */
  size: PropTypes.oneOf(['sm', 'lg']),
}

/**
 * Menu component, originally a copy of what we have in the subheader but reusable, feel free to expand its api
 */
function DropdownMenu(props) {
  const { id, title, items = [], variant = 'primary', toggleClassName = '', size } = props

  return (
    <Dropdown drop="down" className="ms-3" style={{ padding: 0 }}>
      <Dropdown.Toggle variant={variant} id={id} style={{ marginLeft: 0 }} className={toggleClassName} size={size}>
        {title && <FormattedMessage id={title} />}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-end dropdown-menu-anim">
        <ul className="nav margin-t-10 margin-b-10">
          {items.map((item) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            <li className="nav__item" data-bs-toggle="collapse" key={item.id} id={item.id} onClick={item.onClick}>
              <span className="nav__link">
                <span className="nav__link nav__link-text">
                  <FormattedMessage id={item.label} />
                </span>
              </span>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  )
}

DropdownMenu.propTypes = propTypes

export default DropdownMenu
